import { DcsSearchboxComponent } from "./dcs-searchbox.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [DcsSearchboxComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [DcsSearchboxComponent],
  providers:[]
})
export class DcsSearchboxModule {}
